export default __webpack_public_path__ + "static/SuisseIntl-Light-396542919a0d2b8c0c8b3e5cc1fe76f4.woff";